import { useEffect, useState } from 'react';
import { getLayoutMode, type LayoutMode } from './detect';

export function useLayoutMode(): LayoutMode {
  const [mode, setMode] = useState<LayoutMode>(() =>
    typeof window !== 'undefined' ? getLayoutMode(window.innerWidth) : 'desktop',
  );

  useEffect(() => {
    const onResize = () => setMode(getLayoutMode(window.innerWidth));
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return mode;
}
